/**
 * Mail CRDT Service
 * 
 * Thin wrapper around localFirstSyncService for Mail.Draft entities
 * 
 * Handles:
 * - IndexedDB persistence (crash recovery)
 * - WebSocket sync (real-time collaboration + cross-tab)
 * - Server persistence (via websocket server's draft: handler)
 * 
 * Each draft has:
 * - Y.Text('body') - Draft body content
 */

import { localFirstSyncService } from '../../../../services/sync/localFirstSyncService';
import useEntityStore from '../../../../stores/entityStore';

class MailCRDTService {
  /**
   * Get Y.Doc for a draft with IndexedDB + WebSocket sync
   */
  async getYDocForDraft(draftId: string) {
    // Get workspaceId - you may need to adjust this based on your store structure
    const workspaceId = this.getCurrentWorkspaceId();
    
    console.log('[MailCRDT] Getting Y.Doc for draft:', draftId);
    
    return localFirstSyncService.waitForReady(draftId, 'Mail.Draft', workspaceId);
  }
  
  /**
   * Cleanup when component unmounts
   */
  cleanup(draftId: string) {
    const workspaceId = this.getCurrentWorkspaceId();
    
    console.log('[MailCRDT] Cleaning up draft:', draftId);
    
    localFirstSyncService.cleanup(draftId, 'Mail.Draft', workspaceId);
  }
  
  private getCurrentWorkspaceId(): string {
    return useEntityStore.getState().currentDataspaceKey || 'personal';
  }
}

// Singleton instance
export const mailCRDTService = new MailCRDTService();
